import { CalendarClock } from "lucide-react";

import convertToJalali from "@/helpers";

import { useProfile } from "@/hooks/server-state/use-profile";

const LastUpdate = () => {
  const { data } = useProfile();
  console.log(data);
  return (
    <div className="flex items-center gap-x-1">
      <CalendarClock size={12} className="text-[#30aab5]" />
      <p className="">
        {data?.lastUpdate ? (
          <>
            <div className="flex flex-row gap-x-2">
              <div>آخرین بروزرسانی:</div>
              <div>{convertToJalali(data?.lastUpdate)}</div>
            </div></>
        ) : (
          <>ویرایش انجام نشده است</>
        )}
      </p>
    </div>
  );
};

export default LastUpdate;
